import { render, staticRenderFns } from "./confirm-arrival.vue?vue&type=template&id=34774a94&"
import script from "./confirm-arrival.vue?vue&type=script&lang=js&"
export * from "./confirm-arrival.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports